
import { setAdminAuditInfo } from '@/api/task/admin'
import { setAuditStatusRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { delObjEmptyKey } from '@/utils'

@Component({
  name: 'review',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any

  private statusList: any[] = []
  private setForm: any = {
    status: null,
    // reason: '',
    google_code: ''
  }
  private rules = setAuditStatusRules
  private loading: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back(qrUrl: string | null) {
    this.setForm = {
      status: null
    }
    this.loading = false
    this.$emit('close', qrUrl)
  }

  private resetApiKey(apiKey: string | null) {
    this.setForm = {
      status: null
    }
    this.loading = false
    this.$emit('reset', apiKey)
  }

  private async auditOrder() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        const data: any = {
          task_id: this.info.id,
          ...this.setForm
        }
        try {
          await setAdminAuditInfo(data).then((res: any) => {
            this.$message({
              message: 'Operation is successful!',
              type: 'success'
            })

            if (res.task_data?.qrcode || res.task_data?.api_key) {
              const apiKey = res.task_data?.api_key
              const qrUrl = res.task_data?.qrcode
                ? 'data:image/jpeg;base64,' + res.task_data?.qrcode
                : null

              if (apiKey) {
                this.resetApiKey(apiKey)
              } else if (qrUrl) {
                this.back(qrUrl)
              } else {
                this.back(null)
              }
            } else {
              this.back(null)
            }

            this.loading = false
            this.flagStr()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  created() {}
}
